// import { REPORT_CHANNEL, ZT_ROOT_ADDRESS } from '@src/constants';
// import queryParams from '@src/utils/getAppId';
import { LANGUAGE_NAME } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const lang = getLanguageByPath();

export const config = {
  appId: '13297083133',
  appVersion: '1.0',
  channel: 'pc',
  createCommonAttributes: () => {
    return {
      //
      language: LANGUAGE_NAME[getLanguageByPath()]
      //post_url: ZT_ROOT_ADDRESS
    };
  }
};

const gaTrackerBaseEvent = {
  // 发送埋点
  send: (event_name, event_options = {}) => {
    // eslint-disable-next-line no-undef
    if (window.dataLayer) {
      // eslint-disable-next-line no-undef
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('event', event_name, {
        langCode: lang,
        ...event_options,
        transport_type: 'beacon'
      });
    }
  }
};

let startTimeTpl = 0;

export default function createTracker(report, getDiffRouteTime) {
  return {
    // 双端-顶部导航栏-首页
    clickMainNaviBarHome: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_Home');
    },
    // 双端-顶部导航栏-世界观
    clickMainNaviBarTheWorld: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_TheWorld');
    },
    // 双端-顶部导航栏-编年史
    clickMainNaviBarTimeLine: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_TimeLine');
    },
    // 双端-顶部导航栏-官方网站
    clickMainNaviBarOfficialSite: function () {
      gaTrackerBaseEvent.send('click_MainNaviBar_OfficialSite');
    },
    // 顶部导航栏-语言
    clickMainNaviBarLanguage: function (lang) {
      gaTrackerBaseEvent.send('click_MainNaviBar_' + lang);
    },
    // 顶部导航栏-分享
    clickMainNaviBarPlatform: function (name) {
      gaTrackerBaseEvent.send('click_MainNaviBar_' + name);
    },
    // 双端-首页-世界观
    clickHomeTheWorld: function () {
      gaTrackerBaseEvent.send('click_Home_TheWorld');
    },
    // 首页-双端-首页-编年史
    clickHomeTimeLine: function () {
      gaTrackerBaseEvent.send('click_Home_TimeLine');
    },
    pageLoadDuration: function (region) {
      const endTimeTpl = new Date().getTime();
      startTimeTpl = new Date().getTime();
      const tpl = endTimeTpl - startTimeTpl;
      const customEventInfo = {
        eventId: 'page_load_duration', //事件ID
        eventDesc: '用户点进来页面loading加载时长', //事件描述
        eventBody: {
          td_pl: getDiffRouteTime(),
          region: region
        }
      };
      report(customEventInfo);
      // gaTrackerBaseEvent.send('click_start_code');
    },
    clickMESSAGE: function () {
      // const customEventInfo = {
      //   eventId: 'click_dlcmsmk_register', //事件ID
      //   eventDesc: '首页-测试报名，需要可区分五语言（繁中、英语、日语、韩语葡萄牙语）查看数据', //事件描述
      //   eventBody: {}
      // };
      // report(customEventInfo);
      gaTrackerBaseEvent.send('click_MESSAGE');
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
